export enum RESULT_STATE {
    LOADING,
    SUCCESS,
    ERROR
}
